/* Olfé: verlanglijst (hartje op productkaarten, teller in de kop, verlanglijstpagina)
   en snelle weergave (winkelmandje op productkaarten).
   De verlanglijst staat in de browser (localStorage). OlfeWishlist.read/write zijn de enige
   plekken die de opslag raken, zodat daar later een koppeling met het klantaccount achter kan. */
(function () {
  'use strict';

  if (window.OlfeShopReady) return;
  window.OlfeShopReady = true;

  var STORAGE_KEY = 'olfe-wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isDutch = (document.documentElement.lang || 'nl').slice(0, 2) === 'nl';
  var TEXT = isDutch
    ? { added: 'Toegevoegd aan favorieten', removed: 'Verwijderd uit favorieten', close: 'Sluiten', quick: 'Snelle weergave', loading: 'Laden…', error: 'Dit product kon niet worden geladen.', addError: 'Toevoegen is niet gelukt. Probeer het opnieuw.', adding: 'Toevoegen…' }
    : { added: 'Added to wishlist', removed: 'Removed from wishlist', close: 'Close', quick: 'Quick view', loading: 'Loading…', error: 'This product could not be loaded.', addError: 'Could not add to bag. Please try again.', adding: 'Adding…' };

  /* ---------- Verlanglijst: opslag ---------- */

  var Wishlist = {
    read: function () {
      try {
        var list = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(list) ? list.filter(function (item) { return item && item.h; }) : [];
      } catch (error) {
        return [];
      }
    },
    write: function (list) {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (error) { /* geen opslag */ }
      document.dispatchEvent(new CustomEvent('olfe:wishlist', { detail: { items: list } }));
    },
    key: function (handle, variant) { return handle + ':' + (variant || ''); },
    has: function (handle, variant) {
      var key = Wishlist.key(handle, variant);
      return Wishlist.read().some(function (item) { return Wishlist.key(item.h, item.v) === key; });
    },
    toggle: function (handle, variant) {
      var key = Wishlist.key(handle, variant);
      var list = Wishlist.read();
      var index = -1;
      list.forEach(function (item, i) { if (Wishlist.key(item.h, item.v) === key) index = i; });
      if (index > -1) list.splice(index, 1);
      else list.unshift({ h: handle, v: variant || '', t: Date.now() });
      Wishlist.write(list);
      return index === -1;
    }
  };
  window.OlfeWishlist = Wishlist;

  function syncHearts() {
    var list = Wishlist.read();
    var keys = list.map(function (item) { return Wishlist.key(item.h, item.v); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-olfe-wish]'), function (button) {
      var active = keys.indexOf(Wishlist.key(button.getAttribute('data-olfe-wish'), button.getAttribute('data-olfe-variant'))) > -1;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-olfe-wish-count]'), function (el) {
      var text = String(list.length);
      if (el.textContent !== text) el.textContent = text;
      el.hidden = list.length === 0;
    });
  }

  /* ---------- Snelle weergave ---------- */

  var qv = { panel: null, overlay: null, content: null, lastFocus: null, request: 0, variantId: null };

  function buildQuickView() {
    if (qv.panel) return;
    qv.overlay = document.createElement('div');
    qv.overlay.className = 'oqv-overlay';
    qv.overlay.setAttribute('data-oqv-close', '');
    qv.panel = document.createElement('div');
    qv.panel.className = 'oqv';
    qv.panel.setAttribute('role', 'dialog');
    qv.panel.setAttribute('aria-modal', 'true');
    qv.panel.setAttribute('aria-label', TEXT.quick);
    qv.panel.setAttribute('aria-hidden', 'true');
    qv.panel.innerHTML =
      '<button type="button" class="oqv__close" data-oqv-close aria-label="' + TEXT.close + '">' +
      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M3 3l10 10M13 3L3 13"></path></svg>' +
      '</button><div class="oqv__content" data-oqv-content></div>';
    document.body.appendChild(qv.overlay);
    document.body.appendChild(qv.panel);
    qv.content = qv.panel.querySelector('[data-oqv-content]');

    qv.overlay.addEventListener('click', closeQuickView);
    qv.panel.addEventListener('click', onQuickViewClick);
    qv.panel.addEventListener('change', onQuickViewChange);
  }

  function loadQuickView(handle, variant) {
    var request = ++qv.request;
    qv.variantId = null;
    if (!qv.content.querySelector('.oqv-body')) {
      qv.content.innerHTML = '<p class="oqv__status">' + TEXT.loading + '</p>';
    } else {
      qv.content.classList.add('is-loading');
    }
    var url = root + 'products/' + encodeURIComponent(handle) + '?' + (variant ? 'variant=' + encodeURIComponent(variant) + '&' : '') + 'section_id=olfe-quick-view';
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('status ' + response.status);
        return response.text();
      })
      .then(function (html) {
        if (request !== qv.request) return;
        var body = new DOMParser().parseFromString(html, 'text/html').querySelector('.oqv-body');
        if (!body) throw new Error('empty');
        qv.content.innerHTML = '';
        qv.content.appendChild(document.importNode(body, true));
        qv.content.classList.remove('is-loading');
        var single = qv.content.querySelector('.oqv-body').getAttribute('data-single-variant');
        if (single) qv.variantId = single;
      })
      .catch(function () {
        if (request !== qv.request) return;
        qv.content.classList.remove('is-loading');
        qv.content.innerHTML = '<p class="oqv__status">' + TEXT.error + '</p>';
      });
  }

  function openQuickView(handle, variant, trigger) {
    buildQuickView();
    qv.lastFocus = trigger || document.activeElement;
    qv.content.innerHTML = '';
    loadQuickView(handle, variant);
    /* Bij de eerste keer is het paneel net aangemaakt: eerst de dichte stand laten vastleggen,
       anders springt het open in plaats van te schuiven. */
    void qv.panel.offsetWidth;
    qv.panel.classList.add('is-open');
    qv.overlay.classList.add('is-open');
    qv.panel.removeAttribute('aria-hidden');
    document.documentElement.classList.add('oqv-lock');
    window.setTimeout(function () {
      qv.panel.querySelector('.oqv__close').focus({ preventScroll: true });
    }, 60);
  }

  function closeQuickView() {
    if (!qv.panel || !qv.panel.classList.contains('is-open')) return;
    qv.request += 1;
    qv.panel.classList.remove('is-open');
    qv.overlay.classList.remove('is-open');
    qv.panel.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('oqv-lock');
    if (qv.lastFocus && qv.lastFocus.focus && document.contains(qv.lastFocus)) qv.lastFocus.focus({ preventScroll: true });
  }

  function showError(message) {
    var el = qv.content.querySelector('[data-oqv-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function addToCart(button) {
    if (!qv.variantId) {
      var sizes = qv.content.querySelector('.oqv__sizes');
      if (sizes) {
        sizes.classList.remove('is-nudge');
        void sizes.offsetWidth;
        sizes.classList.add('is-nudge');
      }
      return;
    }
    if (button.getAttribute('aria-busy') === 'true') return;
    /* aria-busy laat de themaknop zijn laadpuntjes tonen, net als op de productpagina. */
    button.setAttribute('aria-busy', 'true');
    showError('');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(qv.variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || result.data.message || TEXT.addError);
        return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
      })
      .then(function (cart) {
        button.removeAttribute('aria-busy');
        closeQuickView();
        if (window.theme && window.theme.pubsub) {
          window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'olfe-quick-view', productVariantId: qv.variantId, cart: cart });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })
      .catch(function (error) {
        button.removeAttribute('aria-busy');
        showError(error && error.message ? error.message : TEXT.addError);
      });
  }

  function onQuickViewClick(event) {
    if (event.target.closest('[data-oqv-close]')) return closeQuickView();

    var size = event.target.closest('.oqv__size');
    if (size && !size.disabled) {
      Array.prototype.forEach.call(qv.content.querySelectorAll('.oqv__size'), function (el) {
        el.setAttribute('aria-pressed', el === size ? 'true' : 'false');
      });
      qv.variantId = size.getAttribute('data-variant-id');
      var name = qv.content.querySelector('[data-oqv-size-name]');
      if (name) name.textContent = size.getAttribute('data-size');
      var cta = qv.content.querySelector('[data-oqv-add]');
      if (cta) {
        (cta.querySelector('.btn-text') || cta).textContent = cta.getAttribute('data-label-add');
        cta.classList.add('is-ready', 'button--primary');
        cta.classList.remove('button--secondary');
        cta.removeAttribute('aria-disabled');
      }
      showError('');
      return;
    }

    var chartToggle = event.target.closest('[data-oqv-chart-toggle]');
    if (chartToggle) {
      var chart = document.getElementById(chartToggle.getAttribute('aria-controls'));
      var open = chart.classList.toggle('is-open');
      chartToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var unit = event.target.closest('[data-oqv-unit]');
    if (unit) {
      var value = unit.getAttribute('data-oqv-unit');
      Array.prototype.forEach.call(qv.content.querySelectorAll('[data-oqv-unit]'), function (el) {
        el.setAttribute('aria-pressed', el === unit ? 'true' : 'false');
      });
      Array.prototype.forEach.call(qv.content.querySelectorAll('[data-oqv-table]'), function (el) {
        el.hidden = el.getAttribute('data-oqv-table') !== value;
      });
      return;
    }

    var add = event.target.closest('[data-oqv-add]');
    if (add) addToCart(add);
  }

  function onQuickViewChange(event) {
    var input = event.target;
    if (!input.matches('.oqv__color input')) return;
    var body = qv.content.querySelector('.oqv-body');
    loadQuickView(body.getAttribute('data-handle'), input.getAttribute('data-variant-id'));
  }

  /* ---------- Verlanglijstpagina ---------- */

  function parseShared() {
    var raw = new URLSearchParams(window.location.search).get('items');
    if (!raw) return null;
    return raw.split(',').map(function (part) {
      var bits = part.split(':');
      return { h: bits[0], v: bits[1] || '' };
    }).filter(function (item) { return /^[a-z0-9][a-z0-9-]*$/i.test(item.h) && /^\d*$/.test(item.v); });
  }

  function initWishlistPage() {
    var page = document.querySelector('[data-olfe-wishlist]');
    if (!page || page.olfeReady) return;
    page.olfeReady = true;

    var grid = page.querySelector('[data-olfe-wl-grid]');
    var empty = page.querySelector('[data-olfe-wl-empty]');
    var count = page.querySelector('[data-olfe-wl-count]');
    var title = page.querySelector('[data-olfe-wl-title]');
    var share = page.querySelector('[data-olfe-wl-share]');
    var shareLabel = page.querySelector('[data-olfe-wl-share-label]');
    var save = page.querySelector('[data-olfe-wl-save]');
    var shared = parseShared();
    var render = 0;

    function setCount(number) {
      count.textContent = number + ' ' + (number === 1 ? page.getAttribute('data-one') : page.getAttribute('data-many'));
    }

    function draw() {
      var current = ++render;
      var items = shared || Wishlist.read();
      title.textContent = shared ? page.getAttribute('data-shared-title') : page.getAttribute('data-title');
      setCount(items.length);
      empty.hidden = items.length > 0;
      share.hidden = !!shared || items.length === 0;
      save.hidden = !shared || items.length === 0;
      grid.setAttribute('aria-busy', 'true');

      Promise.all(items.map(function (item) {
        var url = root + 'products/' + encodeURIComponent(item.h) + '?' + (item.v ? 'variant=' + encodeURIComponent(item.v) + '&' : '') + 'section_id=olfe-wishlist-card';
        return fetch(url, { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (html) {
            var card = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.card.product-card') : null;
            return { item: item, card: card };
          })
          .catch(function () { return { item: item, card: null }; });
      })).then(function (results) {
        if (current !== render) return;
        grid.innerHTML = '';
        var shown = 0;
        results.forEach(function (result) {
          if (!result.card) return;
          shown += 1;
          var cell = document.createElement('div');
          cell.className = 'olfe-wl__item';
          cell.appendChild(document.importNode(result.card, true));
          /* Via innerHTML, zodat de themaknop (is="hover-button") met zijn hover-vulling wordt aangemaakt. */
          var holder = document.createElement('div');
          holder.innerHTML = '<button type="button" class="olfe-wl__button button button--primary" is="hover-button"><span class="btn-fill" data-fill></span><span class="btn-text"></span></button>';
          var button = holder.firstChild;
          button.setAttribute('data-olfe-quick', result.item.h);
          button.setAttribute('data-olfe-variant', result.item.v);
          button.querySelector('.btn-text').textContent = page.getAttribute('data-add');
          cell.appendChild(button);
          grid.appendChild(cell);
        });
        setCount(shown);
        empty.hidden = shown > 0;
        grid.removeAttribute('aria-busy');
        syncHearts();
      });
    }

    share.addEventListener('click', function () {
      var items = Wishlist.read().map(function (item) { return item.h + (item.v ? ':' + item.v : ''); }).join(',');
      var url = window.location.origin + window.location.pathname + '?items=' + encodeURIComponent(items);
      var done = function () {
        var original = page.getAttribute('data-share');
        shareLabel.textContent = page.getAttribute('data-copied');
        window.setTimeout(function () { shareLabel.textContent = original; }, 2200);
      };
      if (navigator.share && window.matchMedia('(max-width: 749px)').matches) {
        navigator.share({ title: document.title, url: url }).catch(function () { /* geannuleerd */ });
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
      } else {
        window.prompt('', url);
      }
    });

    save.addEventListener('click', function () {
      var list = Wishlist.read();
      (shared || []).forEach(function (item) {
        if (!Wishlist.has(item.h, item.v)) list.push({ h: item.h, v: item.v, t: Date.now() });
      });
      Wishlist.write(list);
      window.location.href = window.location.pathname;
    });

    /* Een hartje uitzetten op de eigen lijst haalt de kaart weg. */
    document.addEventListener('olfe:wishlist', function () { if (!shared) draw(); });
    draw();
  }

  /* ---------- Gebeurtenissen ---------- */

  document.addEventListener('click', function (event) {
    var heart = event.target.closest('[data-olfe-wish]');
    if (heart) {
      event.preventDefault();
      event.stopPropagation();
      var added = Wishlist.toggle(heart.getAttribute('data-olfe-wish'), heart.getAttribute('data-olfe-variant'));
      heart.classList.remove('is-pop');
      void heart.offsetWidth;
      if (added) heart.classList.add('is-pop');
      return;
    }
    var quick = event.target.closest('[data-olfe-quick]');
    if (quick) {
      event.preventDefault();
      event.stopPropagation();
      openQuickView(quick.getAttribute('data-olfe-quick'), quick.getAttribute('data-olfe-variant'), quick);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeQuickView();
  });

  document.addEventListener('olfe:wishlist', syncHearts);
  window.addEventListener('storage', function (event) { if (event.key === STORAGE_KEY) syncHearts(); });

  var pending = null;
  new MutationObserver(function () {
    window.clearTimeout(pending);
    pending = window.setTimeout(syncHearts, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function boot() {
    syncHearts();
    initWishlistPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
